import { gql } from '@apollo/client';

const GET_ADMIN_DASHBOARD_DATA = gql`
    query Device_status {
        getAdminDashboard {
            device_status {
                active
                inactive
                poweroff
            }
            earnings {
                current_month
                lifetime
            }
            gpu {
                current_month
                devices_count
            }
            temperature {
                current_month
                devices_count
            }
            device_list
        }
    }
`;

export { GET_ADMIN_DASHBOARD_DATA };
